import React from "react";
import "./errorPages.css";

const NotFoundPage = () => (
  <div className="error-page-container">
    <div className="error-icon" aria-label="Warning" role="img">
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="22" stroke="#FFD600" strokeWidth="4" fill="#FFF8E1" />
    <path d="M24 14v12" stroke="#FFD600" strokeWidth="3" strokeLinecap="round"/>
    <circle cx="24" cy="32" r="2" fill="#FFD600" />
  </svg>
</div>
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <p>The page you are looking for does not exist or may have been moved.</p>
    <a className="error-btn" href="/">Go to Homepage</a>
  </div>
);

export default NotFoundPage;
